<template>
  <v-container>
    <div>
      <v-card-title>
        پاسخ به استعلام <v-spacer />
        <v-btn
          color="error"
          @click="
            $router.push({
              path: `${
                $store.getters.tradeRequestSelectedForResponse &&
                $store.getters.tradeRequestSelectedForResponse.id
                  ? '/trade-request-direct-manage-response/' +
                    $store.getters.tradeRequestSelectedForResponse.id
                  : '/trade-request-direct'
              }`,
            })
          "
          >بستن</v-btn
        >
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-sheet
          outlined
          class="pa-4"
          v-if="
            this.$store.getters.tradeRequestSelectedForDisplay.request !=
            'ContractorRecognition'
          "
        >
          <v-checkbox v-model="checkbox" v-if="checkbox"></v-checkbox>
          <v-row>
            <v-col cols="6" md="4">
              <label> موضوع: </label>
              <strong>
                {{
                  $store.getters.tradeRequestResponsesHeader &&
                  $store.getters.tradeRequestResponsesHeader.title
                    ? $store.getters.tradeRequestResponsesHeader.title
                    : ''
                }}</strong
              >
            </v-col>
            <v-col cols="6" md="4">
              <label>تعداد درخواست کالا: </label>
              <strong>
                {{
                  $store.getters.tradeRequestResponsesHeader &&
                  $store.getters.tradeRequestResponsesHeader.quantity
                    ? $store.getters.tradeRequestResponsesHeader.quantity
                    : ''
                }}</strong
              >
            </v-col>
            <v-col cols="6" md="4">
              <label>واحد اندازه گیری: </label>
              <strong>
                {{
                  $store.getters.tradeRequestResponsesHeader &&
                  $store.getters.tradeRequestResponsesHeader
                    .measurementUnitTitle
                    ? $store.getters.tradeRequestResponsesHeader
                        .measurementUnitTitle
                    : ''
                }}
              </strong>
            </v-col>
          </v-row>
        </v-sheet>
        <v-sheet outlined>
          <v-data-table
            :expanded.sync="expanded"
            :single-expand="true"
            item-key="tradeResponseItemId"
            :items="items"
            :headers="
              $store.getters.tradeRequestSelectedForDisplay.request !=
              'ContractorRecognition'
                ? headers
                : contractorRecegnitionHeader
            "
            disable-pagination
            hide-default-footer
            :single-select="true"
            show-select
            v-model="selected"
            checkbox-color="primary"
          >
            <template
              v-slot:item.data-table-select="{ item, isSelected, select }"
            >
              <v-simple-checkbox
                :value="isSelected"
                :readonly="item.disabled"
                :disabled="item.disabled"
                @input="select($event)"
              ></v-simple-checkbox>
            </template>
            <template v-slot:[`item.deliveryStartDateUtc`]="{ item }">
              {{ jalaliDate(item.deliveryStartDateUtc) }}
            </template>
            <template v-slot:[`item.supplierName`]="{ item }">
              <v-btn text @click="getMerchantInfo(item.supplierId)">
                {{ item.supplierName }}</v-btn
              >
            </template>
            <template v-slot:[`item.price`]="{ item }">
              <div v-if="item.price && item.price.amount">
                <!-- {{ item.price && item.price.currency ? item.price.currency : '' }} -->
                {{ item.price.amount | priceSplitter }}
              </div>
            </template>
            <template v-slot:[`item.totalPrice`]="{ item }">
              <div v-if="item.price && item.price.amount">
                <!-- {{ item.price && item.price.currency ? item.price.currency : '' }} -->
                {{ (item.price.amount * item.totalAmount) | priceSplitter }}
              </div>
            </template>
            <template v-slot:[`item.dataTableExpand`]="item">
              <v-btn
                icon
                title="مشاهده سند "
                :color="indexExpanded[item.index] > -1 ? 'primary' : 'error'"
                @click="displayResponsesPerItem(item)"
              >
                <v-icon> mdi-file-document </v-icon>
              </v-btn>
              <br />
              <span>{{
                indexExpanded[item.index] > -1 ? 'مشاهده مدارک' : 'بستن'
              }}</span>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <v-sheet
                  outlined
                  class="ma-4"
                  v-if="
                    documentItems[item.index].length != 0 &&
                    hasOpened[item.index]
                  "
                >
                  <v-data-table
                    :headers="documentHeaders"
                    :items="documentItems[item.index]"
                    hide-default-footer
                    disable-pagination
                  >
                    <template v-slot:[`item.documentTypeTitle`]="slotData">
                      <v-btn
                        text
                        class="blue--text"
                        @click="
                          selectedDoc = slotData.item;
                          documentModal = true;
                        "
                        >{{ slotData.item.documentTypeTitle }}</v-btn
                      >
                    </template>
                    <template v-slot:[`item.description`]="{ item }">
                      {{
                        item.description == '' ? 'وارد نشده' : item.description
                      }}
                    </template>
                    <template v-slot:[`item.fileDownload`]="{ item }">
                      <a
                        target="_blank"
                        :href="
                          item.fileId && item.fileId.fileUrl
                            ? item.fileId.fileUrl
                            : ''
                        "
                        >{{
                          item.fileId && item.fileId.fileUrl ? 'دانلود' : ''
                        }}
                      </a>
                    </template>
                    <template v-slot:[`item.confirmed`]="{ item }">
                      <v-checkbox
                        :readonly="item.readOnly"
                        @click="
                          item.rejected = false;
                          documentConfirmValidationPerItem(item);
                        "
                        v-model="item.confirmed"
                      >
                      </v-checkbox>
                    </template>
                    <template v-slot:[`item.rejected`]="{ item }">
                      <v-menu :close-on-content-click="false" bottom left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            :disabled="item.readOnly"
                            icon
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon
                              v-if="!item.rejected"
                              @click="
                                item.rejected = true;
                                item.confirmed = false;
                                documentRejectValidationPerItem(item);
                              "
                              >mdi-checkbox-blank-outline</v-icon
                            >
                            <v-icon v-else color="primary"
                              >mdi-checkbox-marked</v-icon
                            >
                          </v-btn>
                        </template>

                        <v-list dense class="pa-3">
                          <span>دلایل رد سند انتخاب شود</span>
                          <v-divider />

                          <!-- --------------------------------------------------------------- -->
                          <v-list-item-group
                            v-model="defectTypesList[item.totalIndex]"
                            multiple
                          >
                            <template v-for="(item, i) in defectTypes">
                              <v-divider
                                v-if="!item"
                                :key="`divider-${i}`"
                              ></v-divider>

                              <v-list-item
                                v-else
                                :key="`item-${i}`"
                                :value="item.title"
                                active-class="deep-purple--text text--accent-4"
                              >
                                <template v-slot:default="{ active }">
                                  <v-list-item-content>
                                    <v-list-item-title
                                      v-text="item.displayName"
                                    ></v-list-item-title>
                                  </v-list-item-content>

                                  <v-list-item-action>
                                    <v-checkbox
                                      :input-value="active"
                                      color="deep-purple accent-4"
                                    ></v-checkbox>
                                  </v-list-item-action>
                                </template>
                              </v-list-item>
                            </template>
                          </v-list-item-group>
                          <v-textarea
                            v-model="descriptionBox[item.totalIndex]"
                            dense
                            :required="
                              descriptionBox[item.totalIndex] &&
                              descriptionBox[item.totalIndex].length > 0
                            "
                            :rules="[
                              (v) => {
                                if (v && (v.length > 1024 || v.length < 5)) {
                                  return 'تعداد کاراکتر ها باید بین 5 تا 1024 عدد باشد';
                                } else return true;
                              },
                            ]"
                            outlined
                            label="توضیحات"
                          ></v-textarea>
                        </v-list>
                      </v-menu>
                      <!-- --------------------------------------------------------------- -->
                    </template>
                    <template v-slot:[`item.reviewed`]="{ item }">
                      <v-checkbox
                        :readonly="item.readOnly"
                        @click="documentValidationPerItem(item)"
                        v-model="item.checkboxConfirmation"
                      >
                      </v-checkbox>
                    </template>
                  </v-data-table>
                </v-sheet>
                <strong v-else>
                  توجه: با توجه به اینکه مدرکی جهت ضمیمه پیشنهاد از طرف شما
                  سفارش گذار محترم اعلام نشده است لذا پیوستی در این پیشنهاد وجود
                  ندارد
                </strong>
                <v-spacer />
                <v-btn
                  class="mb-3 mr-3"
                  color="success"
                  :disabled="item.itemStatus != 'Unknown'"
                  v-if="
                    acceptButton[item.index] &&
                    documentItems[item.index] &&
                    documentItems[item.index].docFlag
                  "
                  @click="accept(item)"
                >
                  مدارک مورد قبول است
                </v-btn>
                <v-btn
                  class="mb-3 mr-3"
                  color="error"
                  v-if="rejectButton[item.index]"
                  @click="reject(item)"
                >
                  مدارک مورد قبول نیست
                </v-btn>
              </td>
            </template>
            <template v-slot:[`item.winner`]="{ item }">
              <v-btn
                icon
                title="قبول پیشنهاد"
                @click="chooseWinner(item)"
                :color="
                  (documentItems[item.index] &&
                    documentItems[item.index].docFlag &&
                    item.itemStatus == 'Accepted') ||
                  item.itemStatus == 'Accepted' ||
                  (documentItems[item.index].length == 0 &&
                    hasOpened[item.index])
                    ? 'primary'
                    : ''
                "
              >
                <v-icon> mdi-check </v-icon>
              </v-btn>
              <v-btn
                icon
                title="نهایی سازی"
                @click="finalizeFunc(item)"
                v-if="item.itemStatus == 'Assign' || item.itemStatus == 'Won'"
              >
                <v-icon color="yellow darken-3">mdi-check-all</v-icon>
              </v-btn>
            </template>
          </v-data-table>
          <v-dialog
            v-if="documentModal && selectedDoc != null"
            v-model="documentModal"
            width="700px"
          >
            <v-card>
              <v-card-title>{{ selectedDoc.documentTypeTitle }} </v-card-title>

              <v-img
                :src="
                  selectedDoc.fileId && selectedDoc.fileId.fileUrl
                    ? selectedDoc.fileId.fileUrl
                    : ''
                "
              >
              </v-img>
              <v-card-text class="mt-5">
                <v-row>
                  <v-col cols="12">
                    <label for="">توضیحات:</label>
                    <strong>
                      {{ selectedDoc.description }}
                    </strong>
                  </v-col>
                  <v-col cols="12">
                    <a
                      target="_blank"
                      :href="
                        selectedDoc.fileId && selectedDoc.fileId.fileUrl
                          ? selectedDoc.fileId.fileUrl
                          : ''
                      "
                      >{{
                        selectedDoc.fileId && selectedDoc.fileId.fileUrl
                          ? 'دانلود فایل'
                          : ''
                      }}
                    </a>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-btn color="error" @click="documentHasViewed">بستن </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-if="winnerDialog" v-model="winnerDialog" width="700px">
            <v-card>
              <v-card-title>  قبول پیشنهاد </v-card-title>
              <v-divider />
              <v-card-text>
                <v-row class="pa-5">
                  <v-col cols="6">
                    <label> تعداد پیشنهادی: </label>
                    <strong>
                      {{ selectedAsWinner.totalAmount }}
                    </strong>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      label="تعداد مورد درخواست"
                      dense
                      outlined
                      v-model="committedAmount"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-btn @click="winnerDialog = false" color="error">بستن</v-btn>
                <v-btn @click="submitWinner(selectedAsWinner)" color="primary"
                  > اعلان قبول پیشنهاد</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog
            v-if="merchantInfoModal"
            v-model="merchantInfoModal"
            width="800px"
          >
            <v-card>
              <v-card-text>
                <v-row class="pa-5">
                  <v-col cols="6" md="4">
                    <label for="">نام کسب و کار :</label>
                    <strong>
                      {{ merchantInfo.name }}
                    </strong>
                  </v-col>
                  <v-col cols="6" md="4">
                    <label for="">نوع کسب و کار :</label>
                    <strong>
                      {{
                        merchantInfo.companyTypeGroupItemDto
                          .companyTypeGroupTitle
                      }}
                    </strong>
                  </v-col>
                  <v-col cols="6" md="4">
                    <label for="">نام مدیرعامل :</label>
                    <strong>
                      {{ merchantInfo.managerPerson.firstName }}
                      {{ merchantInfo.managerPerson.lastName }}
                    </strong>
                  </v-col>
                  <v-col
                    cols="6"
                    md="4"
                    v-if="this.merchantInfo.companyTypeGroupId == 1"
                  >
                    <label for="">نوع شرکت :</label>
                    <strong>
                      {{ merchantInfo.company.companyTypeName }}
                    </strong>
                  </v-col>
                  <v-col cols="6" md="4" v-else>
                    <label for="">نوع ثبت :</label>
                    <strong>
                      {{ merchantInfo.company.companyTypeName }}
                    </strong>
                  </v-col>
                  <v-col
                    cols="6"
                    md="4"
                    v-if="this.merchantInfo.companyTypeGroupId == 1"
                  >
                    <label for="">عنوان برند :</label>
                    <strong>
                      {{ merchantInfo.company.brandName }}
                    </strong>
                  </v-col>
                  <v-col
                    cols="6"
                    md="4"
                    v-if="this.merchantInfo.companyTypeGroupId == 1"
                  >
                    <label for="">شناسه ملی :</label>
                    <strong>
                      {{ merchantInfo.company.nationalId }}
                    </strong>
                  </v-col>
                  <v-col
                    cols="6"
                    md="4"
                    v-if="this.merchantInfo.companyTypeGroupId == 1"
                  >
                    <label for="">شناسه ثبت :</label>
                    <strong>
                      {{ merchantInfo.company.registrarNumber }}
                    </strong>
                  </v-col>
                  <v-col cols="6" md="4" v-if="this.merchantInfo.address">
                    <label for="">استان :</label>
                    <strong>
                      {{ merchantInfo.address.stateName }}
                    </strong>
                  </v-col>
                  <v-col cols="6" md="4" v-if="this.merchantInfo.address">
                    <label for="">شهر :</label>
                    <strong>
                      {{ merchantInfo.address.cityName }}
                    </strong>
                  </v-col>
                  <v-col cols="6" md="4" v-if="this.merchantInfo.address">
                    <label for="">شهرک صنعتی :</label>
                    <strong>
                      {{
                        !!merchantInfo.address.industrialParkName
                          ? merchantInfo.address.industrialParkName
                          : 'وارد نشده'
                      }}
                    </strong>
                  </v-col>
                  <v-col cols="12" v-if="this.merchantInfo.address">
                    <label for="">اطلاعات تکمیلی آدرس :</label>
                    <strong>
                      {{
                        !!merchantInfo.address.addressLane
                          ? merchantInfo.address.addressLane
                          : 'وارد نشده'
                      }}
                    </strong>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" @click="merchantInfoModal = false"
                  >بستن</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-sheet>
      </v-card-text>
      <div class="text-center pt-5">
        <v-row>
          <v-col cols="12" sm="2" md="2">
            <v-select
              outlined
              dense
              v-model="itemsPerPage"
              :items="[5, 10, 20]"
              label="تعداد نمایش در صفحه"
            ></v-select>
          </v-col>

          <v-col cols="12" sm="10" md="10">
            <v-pagination
              circle
              v-model="pageNumber"
              :length="pageCount ? pageCount : 1"
              :total-visible="7"
            ></v-pagination>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-container>
</template>

<script>
import asyncLoadMixin from '@/core/mixins/asyncLoadMixin';
import reusableMethodsMixin from '@/core/mixins/reusableMethodsMixin';
const tradeRequestResponseRepository = () =>
  RepoFactory.get('tradeRequestResponse');
const tradeRequestsRepository = () => RepoFactory.get('tradeRequests');
import { RepoFactory } from '@/baseRepository/Factory';
const enumsRepository = () => RepoFactory.get('enums');
const merchantRepository = () => RepoFactory.get('merchant');
import Helper from '@/core/helpers';
import TradeRequestFinalizeForm from './TradeRequestFinalizeForm.vue';
export default {
  mixins: [asyncLoadMixin, reusableMethodsMixin],
  components: { TradeRequestFinalizeForm },
  data() {
    return {
      pageNumber: 1,
      pageCount: 0,
      itemsPerPage: 10,
      selectedToFinalize: null,
      selected: [],
      finalizeForm: false,
      finalizeFlag: false,
      merchantInfoModal: false,
      merchantInfo: null,
      checkbox: false,
      committedAmount: null,
      selectedAsWinner: null,
      winnerDialog: false,
      defectTypesList: [],
      descriptionBox: [],
      index: 0,
      hasOpened: [],
      defectTypes: null,
      acceptButton: [],
      rejectButton: [],
      selectedDoc: null,
      documentModal: false,
      expanded: [],
      indexExpanded: [],
      documentItems: [],
      documentHeaders: [
        {
          value: 'documentTypeTitle',
          text: 'نوع سند',
          sortable: true,
        },
        {
          value: 'description',
          text: 'توضیحات',
          sortable: true,
        },
        {
          value: 'fileDownload',
          text: 'دانلود فایل',
          sortable: true,
        },
        {
          text: 'وضعیت مشاهده',
          value: 'reviewed',
        },
        {
          value: 'confirmed',
          text: 'تایید شده ',
          sortable: true,
        },
        {
          value: 'rejected',
          text: 'رد شده',
          sortable: true,
        },
      ],
      items: [],
      contractorRecegnitionHeader: [
        {
          value: 'supplierName',
          text: 'نام پیشنهاد دهنده',
          sortable: true,
        },
        {
          value: 'dataTableExpand',
          text: 'مشاهده اسناد',
          sortable: true,
        },
        {
          value: 'winner',
          text: ' قبول و نهایی سازی',
          sortable: true,
        },
      ],
      headers: [
        {
          value: 'supplierName',
          text: 'نام پیشنهاد دهنده',
          sortable: true,
        },
        {
          value: 'totalAmount',
          text: 'تعداد پیشنهادی',
          sortable: true,
        },
        {
          value: 'price',
          text: 'قیمت واحد (ریال)',
          sortable: true,
        },
        {
          value: 'totalPrice',
          text: 'قیمت کل(ریال)',
          sortable: true,
        },
        {
          value: 'dataTableExpand',
          text: 'مشاهده اسناد',
          sortable: true,
        },
        {
          value: 'winner',
          text: ' قبول و نهایی سازی',
          sortable: true,
        },
      ],
    };
  },
  created() {
    this.getDefectTypes();
    if (
      this.$store.getters.tradeRequestResponsesPerItem &&
      this.$store.getters.tradeRequestResponsesPerItem.totalCount > 0
    ) {
      this.items = this.$store.getters.tradeRequestResponsesPerItem.list;
      this.items.forEach((x, i) => {
        x.index = i;
        x.disabled = true;
        this.indexExpanded.push('');
        this.documentItems.push([]);
        this.hasOpened.push(false);
        this.descriptionBox.push('');
        this.defectTypesList.push([]);
        this.acceptButton.push(false);
        this.rejectButton.push(false);
        this.defectTypesList.push(false);
        if (x.itemStatus == 'Won') {
          // this.finalizeFlag = true;
          this.selected.push(x);
        }
      });
    } else {
      this.items = [];
    }
  },
  computed: {
    tradeBaseUrl() {
      return this.$store.getters.tradeBaseUrl;
    },
    merchantId() {
      return this.$store.getters.currentMerchant;
    },
    merchantBaseUrl() {
      return this.$store.getters.merchantBaseUrl;
    },
  },
  methods: {
    getDefectTypes() {
      const loader = this.$loading.show();
      enumsRepository()
        .getEnum('TradeResponseDocumentsDefectType', this.tradeBaseUrl)
        .then((res) => {
          this.defectTypes = res.data;
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        });
    },
    displayResponsesPerItem(slotData) {
      this.clickColumn(slotData);
      this.index = slotData.index;
    },
    clickColumn(slotData) {
      const indexRow = slotData.index;
      this.indexExpanded[indexRow] = this.expanded.findIndex(
        (i) => i === slotData.item
      );

      if (this.indexExpanded[indexRow] > -1) {
        this.expanded.splice(this.indexExpanded[indexRow], 1);
      } else {
        this.expanded.push(slotData.item);
        this.getDocument(slotData);
      }
    },
    getDocument(slotData) {
      let app = this;

      if (app.documentItems[slotData.index].length == 0) {
        const loader = this.$loading.show();
        tradeRequestResponseRepository()
          .getDocuments(
            slotData.item.tradeResponseId,
            this.tradeBaseUrl,
            {},
            { responseItemId: slotData.item.tradeResponseItemId }
          )
          .then((res) => {
            // app.documentItems[slotData.index] = []
            res.data.forEach((x, i) => {
              //
              x.checkboxConfirmation =
                slotData.item.itemStatus == 'Assign' ||
                slotData.item.itemStatus == 'Accepted' ||
                slotData.item.itemStatus == 'Won'
                  ? true
                  : false;
              x.confirmed =
                slotData.item.itemStatus == 'Assign' ||
                slotData.item.itemStatus == 'Accepted' ||
                slotData.item.itemStatus == 'Won'
                  ? true
                  : false;
              x.rejected = false;
              x.readOnly =
                slotData.item.itemStatus == 'Assign' ||
                slotData.item.itemStatus == 'Accepted' ||
                slotData.item.itemStatus == 'Won'
                  ? true
                  : false;
              x.index = i;
              x.totalIndex = slotData.index;
              app.documentItems[slotData.index].push(x);
            });
            app.hasOpened[slotData.index] = true;
            app.checkbox = true;
            app.checkbox = false;
            app.items[slotData.index].price;
            if (
              slotData.item.itemStatus != 'Accepted' &&
              slotData.item.itemStatus != 'Assign' &&
              slotData.item.itemStatus != 'Won' &&
              app.documentItems[slotData.index].length == 0 &&
              (app.items[slotData.index].price == null ||
                this.$store.getters.tradeRequestSelectedForDisplay.request ==
                  'ContractorRecognition')
            ) {
              app.accept(app.items[slotData.index]);
            }
            //
            loader.hide();
          })
          .catch((err) => {
            Helper.handleErrors(err, this);
            loader.hide();
          });
      }
    },
    documentHasViewed() {
      this.documentItems[this.selectedDoc.totalIndex][
        this.selectedDoc.index
      ].checkboxConfirmation = true;
      this.documentValidationPerItem(this.selectedDoc);
      this.selectedDoc = null;
      this.documentModal = false;
    },
    documentValidationPerItem(item) {
      this.documentItems[item.totalIndex].docFlag = false;
      this.checkbox = true;
      this.checkbox = false;
      let flag = true;
      this.documentItems[item.totalIndex].forEach((x, i) => {
        if (!x.checkboxConfirmation) flag = false;
      });
      if (flag) {
        this.documentItems[item.totalIndex].docFlag = true;
        // this.getPrice(item)
        this.checkbox = true;
        this.checkbox = false;
      }
    },
    documentConfirmValidationPerItem(item) {
      this.documentItems[item.totalIndex].confirmFlag = false;
      let flag = true;
      let rejFlag = false;
      this.documentItems[item.totalIndex].forEach((x, i) => {
        if (!x.confirmed) flag = false;
        if (x.rejected) rejFlag = true;
      });
      if (flag) {
        this.documentItems[item.totalIndex].confirmFlag = true;
        this.acceptButton[item.totalIndex] = true;
        this.checkbox = true;
        this.checkbox = false;
      } else {
        this.acceptButton[item.totalIndex] = false;
        this.checkbox = true;
        this.checkbox = false;
      }
      if (rejFlag) {
        this.documentItems[item.totalIndex].rejectFlag = true;
        this.rejectButton[item.totalIndex] = true;
        this.checkbox = true;
        this.checkbox = false;
      } else {
        this.rejectButton[item.totalIndex] = false;
        this.checkbox = true;
        this.checkbox = false;
      }
    },
    documentRejectValidationPerItem(item) {
      this.documentItems[item.totalIndex].rejectFlag = false;
      let flag = false;
      let conFlag = true;
      this.documentItems[item.totalIndex].forEach((x, i) => {
        if (x.rejected) flag = true;
        if (!x.confirmed) conFlag = false;
      });
      if (flag) {
        this.documentItems[item.totalIndex].rejectFlag = true;
        this.rejectButton[item.totalIndex] = true;
        this.checkbox = true;
        this.checkbox = false;
      } else {
        this.rejectButton[item.totalIndex] = false;
        this.checkbox = true;
        this.checkbox = false;
      }
      if (conFlag) {
        this.documentItems[item.totalIndex].confirmFlag = true;
        this.acceptButton[item.totalIndex] = true;
        this.checkbox = true;
        this.checkbox = false;
      } else {
        this.acceptButton[item.totalIndex] = false;
        this.checkbox = true;
        this.checkbox = false;
      }
    },
    getPrice(item) {
      if (this.items[item.index].price == null) {
        const loader = this.$loading.show();
        tradeRequestResponseRepository()
          .getPrice(
            this.items[item.index].tradeResponseId,
            this.tradeBaseUrl,
            { merchantId: this.merchantId },
            {
              tradeRequestItemId: this.items[item.index].tradeRequestItemId,
            }
          )
          .then((res) => {
            this.items[item.index].price = res.data.price;
            loader.hide();
          })
          .catch((err) => {
            Helper.handleErrors(err, this);
            loader.hide();
          });
      }
    },
    accept(item) {
      let body = {
        tradeRequestId: item.tradeRequestId,
        tradeResponseItemId: item.tradeResponseItemId,
      };
      const loader = this.$loading.show();
      tradeRequestResponseRepository()
        .accept(item.tradeResponseId, body, this.tradeBaseUrl)
        .then((res) => {
          this.$dialog.message.success(' با موفقیت ارسال شد. ', {
            position: 'top-left',
          });
          //
          item.itemStatus == 'Unknown' ? (item.itemStatus = 'Accepted') : '';
          this.getPrice(item);

          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        });
    },
    reject(item) {
      let body = {
        tradeRequestId: item.tradeRequestId,
        tradeResponseItemId: item.tradeResponseItemId,
        documentsDefectTypes: this.defectTypesList[item.index],
        rejectDescription: this.descriptionBox[item.index],
      };
      const loader = this.$loading.show();
      tradeRequestResponseRepository()
        .reject(item.tradeResponseId, body, this.tradeBaseUrl)
        .then((res) => {
          this.$dialog.message.success(' با موفقیت ارسال شد. ', {
            position: 'top-left',
          });
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        });
    },
    chooseWinner(item) {
      if (item.itemStatus == 'Assign' || item.itemStatus == 'Won') {
        this.$dialog.info({
          text: 'قبلا قبول پیشنهاد برای این قلم ثبت شده است ',
          title: 'خطا',
          persistent: true,
          actions: [
            {
              text: 'بستن',
              color: 'red',
            },
          ],
        });
        return;
      }
      if (
        this.$store.getters.tradeRequestSelectedForDisplay.request !=
          'ContractorRecognition' &&
        ((this.documentItems[item.index] &&
          this.documentItems[item.index].docFlag &&
          item.itemStatus == 'Accepted') ||
          item.itemStatus == 'Accepted' ||
          (this.documentItems[item.index].length == 0 &&
            this.hasOpened[item.index]))
      ) {
        this.winnerDialog = true;
        this.selectedAsWinner = item;
        this.committedAmount = this.selectedAsWinner.totalAmount;
      } else if (
        this.$store.getters.tradeRequestSelectedForDisplay.request ==
          'ContractorRecognition' &&
        ((this.documentItems[item.index] &&
          this.documentItems[item.index].docFlag &&
          item.itemStatus == 'Accepted') ||
          item.itemStatus == 'Accepted' ||
          (this.documentItems[item.index].length == 0 &&
            this.hasOpened[item.index]))
      ) {
        this.selectedAsWinner = item;
        this.committedAmount = 1;
        this.submitWinner(this.selectedAsWinner);
      } else {
        this.$dialog.error({
          text: 'ابتدا اسناد مربوطه را مشاهده و تایید نمایید',
          title: 'خطا',
          persistent: true,
          actions: [
            {
              text: 'بستن',
              color: 'red',
            },
          ],
        });
      }
    },
    submitWinner(item) {
      if (item.itemStatus == 'Assign' || item.itemStatus == 'Won') {
        this.$dialog.info({
          text: 'قبلا قبول پیشنهاد برای این قلم ثبت شده است ',
          title: 'خطا',
          persistent: true,
          actions: [
            {
              text: 'بستن',
              color: 'red',
            },
          ],
        });
        return;
      } else {
        let body = {
          tradeResponseItemId: item.tradeResponseItemId,
          committedAmount: this.committedAmount,
        };
        const loader = this.$loading.show();
        tradeRequestResponseRepository()
          .assign(item.tradeResponseId, body, this.tradeBaseUrl, {
            merchantId: this.merchantId,
          })
          .then((res) => {
            this.$dialog.message.success(' با موفقیت تخصیص داده شد. ', {
              position: 'top-left',
            });
            this.finalizeFlag = true;
            this.winnerDialog = false;
            this.checkbox = true;
            this.checkbox = false;
            this.getResponsesPerItem();

            loader.hide();
          })
          .catch((err) => {
            Helper.handleErrors(err, this);
            loader.hide();
          });
      }
    },
    finalize() {
      // this.finalizeForm =true
      const loader = this.$loading.show();
      tradeRequestsRepository()
        .finalize(
          this.$store.getters.tradeRequestSelectedForDisplay.id,
          this.tradeBaseUrl,
          { merchantId: this.merchantId }
        )
        .then((res) => {
          this.$dialog.message.success(' با موفقیت نهایی شد. ', {
            position: 'top-left',
          });
          this.finalizeFlag = false;
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        });
    },
    finalizeFunc(item) {
      // this.finalizeForm =true
      this.$store.commit('setTradeRequestSelectedToFinalize', item);
      this.$router.push({ path: `/trade-request-finalize` });
    },
    getMerchantInfo(id) {
      const loader = this.$loading.show();
      merchantRepository()
        .getMerchantInformationById(id, this.merchantBaseUrl)
        .then((res) => {
          this.merchantInfo = res.data;
          this.merchantInfoModal = true;
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        })
        .finally(() => loader.hide());
    },
    getResponsesPerItem() {
      let item = this.$store.getters.tradeRequestResponsesHeader;
      let params = {
        tradeRequestItemId: item.id,
        PageNumber: this.pageNumber,
        ItemsPerPage: this.itemsPerPage,
      };
      const loader = this.$loading.show();
      tradeRequestResponseRepository()
        .getAllResponsesPerItem(
          this.tradeBaseUrl,
          { MerchantId: this.merchantId },
          params
        )
        .then((res) => {
          this.$store.commit('setTradeRequestResponsesPerItem', res.data);
          this.items = [];
          if (res.data.list != null) {
            this.items = res.data.list;
          } else {
            this.items = [];
          }
          this.items.forEach((x, i) => {
            x.index = i;
            x.disabled = true;
            this.indexExpanded.push('');
            this.documentItems.push([]);
            this.descriptionBox.push('');
            this.defectTypesList.push([]);
            this.acceptButton.push(false);
            this.rejectButton.push(false);
            this.defectTypesList.push(false);
            if (x.itemStatus == 'Won') {
              // this.finalizeFlag = true;
              this.selected.push(x);
            }
          });
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        });
    },
  },
  watch: {
    pageNumber() {
      this.getResponsesPerItem();
    },
    itemsPerPage() {
      this.pageNumber = 1;
      this.getResponsesPerItem();
    },
  },
};
</script>

<style></style>
